import { useEcomStore, useUiStore } from '@/data';

import { useShoppingMode } from './useShoppingMode';

const useDeepLinkFulfillmentMethod = () => {
  const [, setStoredState] = useEcomStore();
  const [, setUIState] = useUiStore();
  const { onlyPickup } = useShoppingMode();

  const deepLinkFulfillmentMethod = (method?: string) => {
    if (!method) return;

    if (method === 'pickup') {
      setStoredState({
        delivery_details: {
          delivery: false,
          pickup: true,
        },
      });
    } else if (method === 'delivery') {
      if (onlyPickup) return;

      setStoredState({
        delivery_details: {
          delivery: true,
          pickup: false,
        },
      });
      setUIState({ is_store_location_open: true });
    }
  };

  return { deepLinkFulfillmentMethod };
};

export { useDeepLinkFulfillmentMethod };
